"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var validate_exports = {};
__export(validate_exports, {
  validateListener: () => validateListener
});
module.exports = __toCommonJS(validate_exports);
function validateListener(sensor, intervalMs, onReading, onError) {
  if (![
    "accelerometer",
    "gyroscope",
    "magnetometer",
    "deviceMotion"
  ].includes(sensor)) throw new TypeError("Motion.addListener requires a supported sensor");
  if (!Number.isFinite(intervalMs) || intervalMs < 0 || intervalMs > 1e3) throw new RangeError("Motion.addListener intervalMs must be between 0 and 1000");
  if (typeof onReading !== "function" || typeof onError !== "function") throw new TypeError("Motion.addListener requires reading and error callbacks");
}
//# sourceMappingURL=validate.js.map
